module.exports = __webpack_public_path__ + "images/Write.94f732f0a51dcadaf05b6d35acb144a1.png";